// Global Instructions Rule Applied!

import {
  fetchFundraisingById,
  createFundraising,
  updateFundraising
} from '../../../app_modules/fundraising/services/fundraisingService.ts'
import { setFundraising, updateProspectRecord, addProspect } from './fundraising_actions.ts'
import { ProspectRecord } from '../../interfaces/fundraising.ts'
import { AppDispatch } from '../../store.ts'

/**Fetches a prospect by ID. */
const fetchProspectByIdService = async (
  prospectId: string | number,
  accessToken: string | null,
  dispatch: AppDispatch
): Promise<{ data: ProspectRecord | null; error?: string }> => {
  try {
    const response = await fetchFundraisingById(prospectId, accessToken)

    if (response.error) {
      return { data: null, error: response.error }
    }

    return { data: response.data as ProspectRecord | null }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to fetch prospect'
    return { data: null, error: errorMessage }
  }
}

/**Creates a new prospect and dispatches addProspect action. */
export const createFundraisingService = async (
  prospectData: Record<string, any>,
  accessToken: string | null,
  dispatch: AppDispatch
): Promise<{ data: ProspectRecord | null; error?: string }> => {
  try {
    const response = await createFundraising(prospectData, accessToken)

    if (response.error) {
      return { data: null, error: response.error }
    }

    if (response.data) {
      dispatch(addProspect({ prospect: response.data as ProspectRecord }))
    }

    return { data: response.data as ProspectRecord | null }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to create prospect'
    return { data: null, error: errorMessage }
  }
}

/**Updates an existing prospect and dispatches updateProspectRecord action. */
export const updateFundraisingService = async (
  prospectId: string | number,
  prospectData: Record<string, any>,
  accessToken: string | null,
  dispatch: AppDispatch
): Promise<{ data: ProspectRecord | null; error?: string }> => {
  try {
    const response = await updateFundraising(prospectId, prospectData, accessToken)

    if (response.error) {
      return { data: null, error: response.error }
    }

    if (response.data) {
      const updatedProspect = response.data as ProspectRecord
      const idString = prospectId.toString()

      dispatch(
        updateProspectRecord({
          prospectId: idString,
          updates: updatedProspect
        })
      )
    }

    return { data: response.data as ProspectRecord | null }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to update prospect'
    return { data: null, error: errorMessage }
  }
}
